import React from 'react';
import { createFieldClass, controls, Errors } from 'react-redux-form';
import cx from 'classnames';
import MaskedInput from 'react-maskedinput';
import VirtualizedSelect from 'react-virtualized-select';

import PhoneInput from './PhoneInput';
import Label from './Label';
import styles from './TextField.css';

const Field = createFieldClass({
  ...controls,
  PhoneInput: controls.default,
  // Can't use controls.default for this one.
  // When a component defines a default prop for `value`, this default prop
  // will take over at initialization.
  MaskedInput: props => ({
    ...props,
    value: props.modelValue,
    onChange: props.onChange,
  }),
  VirtualizedSelect: controls.default,
}, {
  componentMap: {
    PhoneInput,
    MaskedInput,
    VirtualizedSelect,
  },
});

export default function TextField(props) {
  const {
    label,
    required,
    validators: otherValidators,
    messages,
    model,
    inputComponent: InputComponent = 'input',
    inputProps = {},
    noStyle = false,
    ...otherProps,
  } = props;

  const validators = { ...otherValidators };
  if (required) {
    validators.required = v => v && v.length > 0;
  }

  const field = (
    <Field model={model} validators={validators} {...otherProps}>
      <InputComponent
        className={cx(!noStyle && [
          styles.textInput,
          required && styles.required,
        ])}
        {...inputProps}
      />
    </Field>
  );

  const content = label ?
    <Label label={label}>
      {field}
    </Label> :
    field;

  return (
    <div className={styles.fieldContainer}>
      {content}
      <Errors
        model={model}
        className={styles.fieldErrors}
        show="touched"
        messages={{
          required: 'Merci de renseigner ce champ',
          ...messages,
        }}
      />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/TextField.js
 **/